import { z } from 'zod';

import { LosId, PaymentId } from '../../BrandedIds';
import { PaymentMethod, PaymentStatus } from '../../loan/Payments';
import { zodTemporalInstant } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

/**
 * This is pretty bare and needs more fields from the whole union type.
 */
export const ExportablePayment = z
  .object({
    id: zodBrandedUuid<PaymentId>(),
    loanId: zodBrandedString<LosId>(),
    total: z.number(),
    method: PaymentMethod,
    /**
     * Commented out for now while since we don't want to take on the mixed date migration as part of this PR.
     * https://github.com/willowservicing/willow/pull/10174#discussion_r2914967293
     */
    // paymentDate: zodTemporalInstant,
    status: PaymentStatus,
    createdAt: zodTemporalInstant,
  })
  .meta({ title: 'Payment' });
export type ExportablePayment = z.infer<typeof ExportablePayment>;
